const LandingPage = () => {
  return (
    <>
      <div className='h-[90vh]'>
        <div className='landing-page-text'>
          <p className='text-first tracking-tight text-[90px] sm:text-[120px] md:text-[140px] lg:text-[170px]'>
            Merch Zone
          </p>
          <p className='text-second text-[20px] sm:text-[20px] lg:text-[25px]'>
            One stop for all your favourite Merch
          </p>
        </div>
      </div>
    </>
  );
};

export default LandingPage;
